// extracted by mini-css-extract-plugin
export default {"container":"CompanyContactInfo_container__KpGsc","hr":"CompanyContactInfo_hr__SFQ85","firstTitle":"CompanyContactInfo_firstTitle__IpsH8","date":"CompanyContactInfo_date__7vleW"};